import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() isSuccess: boolean = true;
  isVisible: boolean = false;

  @Output() close = new EventEmitter<void>();

  openModal(title: string, message: string, isSuccess: boolean): void {
    this.title = title;
    this.message = message;
    this.isSuccess = isSuccess;
    this.isVisible = true;
  }

  closeModal(): void {
    this.isVisible = false;
    this.close.emit();
  }
}
